import React, { useCallback, useEffect, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { JqueryClassFaker } from "../../components/JqueryClassFaker";

MaterialInput.instances = 1;

function MaterialInput(props, passedRef) {

	const instanceNumber = useRef(null);
	const inputRef = useRef(null);

	if(!instanceNumber.current) {
		instanceNumber.current = MaterialInput.instances++;
	}

	useEffect(() => {
		if(!isMobile && props.focusOnMount && inputRef.current) {
			inputRef.current.focus();
		}
	}, []);

	useEffect(() => {
		if(!isMobile && props.shouldFocus) {
			inputRef.current.focus();
		}
	}, [isMobile, inputRef.current, props.shouldFocus]);

	const setInputRef = useCallback((ref) => {
		if(inputRef.current === ref) {
			return;
		}
		inputRef.current = ref;
		if(passedRef) {
			passedRef(ref);
		}
	}, [props.setRef]);

	const { label, useDefaultClassNames, shouldFocus, focusOnMount, className, ...otherProps } = props;
	const classes = new JqueryClassFaker(className);
	if(useDefaultClassNames || useDefaultClassNames === undefined) {
		classes.add('text-input').add('browser-default');
	}
	return (
		<div className='material-input'>
			<div className='group'>
				<input
					ref={setInputRef}
					id={`material-input-${instanceNumber.current}`}
					className={classes.toString()}
					type='text'
					required
					{...otherProps}
				/>
				<label className='label' htmlFor={`material-input-${instanceNumber.current}`}>{label}</label>
			</div>
		</div>
	);
}

export default React.forwardRef(MaterialInput);
